import styled from 'styled-components';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { LAYOUT } from '@/constants/styles';

export const StyledReorderConfirmContent = styled.div`
  padding: ${LAYOUT.GUTTER}px;
  padding-top: 0px;
  display: flex;
  flex-direction: column;
`;

export const StyledConfirmMessage = styled.p(() => ({
  fontSize: '14px',
  lineHeight: '20px',
  margin: '0 0 16px',
  textAlign: 'center',
}));

export const StyledReorderFooter = styled.div`
  margin-top: 32px;
  display: flex;
  gap: 12px;
`;

export const StyledConfirmButton = styled(StyledPrimaryButton)(() => ({
  fontSize: '16px',
  width: '100%',
}));

export const StyledCancelButton = styled(StyledConfirmButton)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: theme.global.primary_active_color,

  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.global.primary_active_color,
    textDecoration: 'underline',
    color: theme.global.primary_active_color,
  },
}));
